import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography, Button, IconButton } from '@mui/material'
import LoadingCircle from './LoadingCircle';
import ReactPlayer from 'react-player';
import FavoriteIcon from '@mui/icons-material/Favorite';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

const BACKEND_URL = process.env.REACT_APP_BACKEND;

export default function InfoPage({ workshop: workshopData, favourite, onToggleFavourite, onClose }) {

  const documentId = workshopData.documentId;
  const [workshop, setWorkshop] = useState(null);
  const [imageURL, setImageURL] = useState(null);
  const [videoURL, setVideoURL] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    let isMounted = true;

    const fetchData = async () => {
      try {
        const workshop_response = await axios.get(`${BACKEND_URL}/api/workshops?populate=*&filters[documentId][$eq]=${documentId}`);
        const workshop_data = workshop_response.data.data;

        const availability_response = await axios.get(`${BACKEND_URL}/api/workshops/${documentId}/available`);
        const availability_data = availability_response.data.data;

        const aggregate_data = { ...workshop_data[0], 'availableSpots': availability_data };

        if (!aggregate_data.image) {
          setImageURL("https://placehold.co/600x400")
        } else {
          setImageURL(`${aggregate_data.image.url}`)
        }

        if (aggregate_data.video_URL) {
          setVideoURL(`${aggregate_data.video_URL}`)
        }

        if (isMounted) {
          setWorkshop(aggregate_data);
          setLoading(false);
        }

      } catch (err) {
        console.error(err);
      }
    }

    fetchData();

    return () => {
      isMounted = false;
    }

  }, [documentId]);

  if (loading) return <LoadingCircle />;

  return (
    <div>
      <Box
        sx={{
          mb: 3,
        }}
      >

        {/* Close button */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mt: 1.5,
          }}
        >
          <Button
            variant="outlined"
            onClick={onClose}
            endIcon={<KeyboardArrowDownIcon />}
            sx={{
              backgroundColor: 'background.paper',
              borderColor: 'primary.main',
              color: 'primary.main',
              textTransform: 'none',
              fontSize: '0.95rem',
              fontWeight: 500,
              borderRadius: 2,
              px: 12,
              py: 1,

              '&:hover': {
                backgroundColor: 'action.hover',
                borderColor: 'primary.dark',
              },
            }}
          >
            Sulge kirjeldus
          </Button>
        </Box>

        {/* Title + favourite */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
          }}
        >
          <Typography
            variant="h4"
            component="h1"
            sx={{
              m: 0,
              lineHeight: 1.2,
              fontSize: {
                xs: '1.5rem',
                sm: '2rem',
              },
            }}
          >
            {workshop.name}
          </Typography>

          <IconButton
            aria-label={
              favourite
                ? 'Remove from favourites'
                : 'Add to favourites'
            }
            onClick={() => onToggleFavourite(workshop.documentId)}
            sx={{
              flexShrink: 0,
            }}
          >
            {favourite ? (
              <FavoriteIcon color="error" />
            ) : (
              <FavoriteBorderIcon />
            )}
          </IconButton>
        </Box>
      </Box>

      <p>{workshop.description}</p>
      <Box
        sx={{
          display: "flex",
          height: "100%"
        }}>
        <Typography component={'span'} variant="body2" sx={{
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          minHeight: '3em', color: 'text.primary', mb: 1.5
        }}>
          <br />
          {workshop.organization}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            md: '1fr 1fr',
          },
          gap: 3,
          mt: 3,
          mb: 4,
        }}
      >
        {/* Image */}
        <Box
          sx={{
            width: '100%',
            aspectRatio: '16 / 9',
            overflow: 'hidden',
            borderRadius: 2,
            backgroundColor: 'grey.100',
          }}
        >
          <Box
            component="img"
            src={imageURL}
            alt={workshop.name}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              display: 'block',
            }}
          />
        </Box>

        {/* Video */}
        {videoURL ? (
          <Box
            sx={{
              width: '100%',
              aspectRatio: '16 / 9',
              overflow: 'hidden',
              borderRadius: 2,
              backgroundColor: 'grey.100',
            }}
          >
            <ReactPlayer
              src={videoURL}
              controls
              width="100%"
              height="100%"
            />
          </Box>
        ) : null}
      </Box>
    </div>
  );


}
